import * as React from 'react';
import { SVGProps } from 'react';

const IconTable2SizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1 1.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5v-9ZM2 5v2h3.5V5H2Zm4.5 0v2H10V5H6.5ZM10 4H6.5V2H10v2ZM5.5 2v2H2V2h3.5ZM10 8H6.5v2H10V8Zm-4.5 2V8H2v2h3.5Z"
    />
  </svg>
);
export default IconTable2SizeXs;
